module.exports = __webpack_public_path__ + "static/img/3.35101b35.png";